<template>
    <div class="col-12">
        <transition name="fade" mode="out-in">
            <div class="row" v-if="!loading" key="mapa-butacas" id="mapa-butacas">
                <div class="col-12 mb-2 p-0 d-md-flex d-block justify-content-between">
                    <h3>Seleccione las butacas para asignarles precios:</h3>
                </div>
                <div class="lightgray-content col-12 p-2">
                    <ContentOrLoading :class="!svgRendered ? 'padding: 50px;' : ''">
                        <LeafletComponent
                            v-if="svgRendered"
                            :butacasSeleccionadas="butacasSeleccionadas"
                            :svgRendered="svgRendered"
                            :originalColor="originalColor"
                            @isPanning="(e) => isPanning = e"
                        />
                    </ContentOrLoading>
                </div>
                <div class="col-12 p-0 pt-3" v-if="butacasSeleccionadas.length > 0">
                    <PreciosButacasComponent :tipos="tipos" :butacas="butacasSeleccionadas" :recinto_id="recinto.id" @getButacas="recargar" :key="reloadComponent"/>
                </div>
            </div>
            <div class="row" v-else>
                <div class="col-12 text-center" style="height: 400px">
                    <LoaderComponent></LoaderComponent>
                </div>
            </div>                            
        </transition>
    </div>
</template>

<script>
import LeafletComponent from '@/components/svg/components/LeafletComponent.vue';
import { Popover } from 'bootstrap';
import PreciosButacasComponent from '@/components/backend/abonos/precios/PreciosButacasComponent';

export default {
    props: ['recinto', 'tipos'],
    data() {
        return {
            loading: false,
            butacasSeleccionadas: [],
            originalColor: '#0CBA31',
            noDisponibleColor: 'gray',
            seleccionadaColor: '#8CA9D9',
            svgRendered: null,
            isPanning: null,
            reloadComponent: 1,
            butacas: null,
            svg: null
        }   
    },
    methods: {
        getButacas() {
            this.loading = true;

            const params = {
                filters : this.filters,
                lista_id: this.lista_id,
                recinto_id: this.recinto.id
            };

            this.$store.dispatch(this.config.getVuexAlias('back.lista.settings.recinto.butacas'), params).then(res => {
                this.butacas = res.data.data;
                this.getSvg();
            }).finally(() => this.loading = false);
        },
        getSvg() {
            this.loading = true;

            const params = {
                recinto_id: this.recinto.id
            };

            this.$store.dispatch(this.config.getVuexAlias('front.recinto.svg'), params).then(res => {
                this.svg = res.data.svg;
                this.renderLeafletSvg(this.svg);
            }).finally(() => this.loading = false);
        },
        renderLeafletSvg(svg) {
            const butacasFiltered = this.butacas.filter(butaca => butaca.svg_id);
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = svg;

            const svgElement = tempDiv.firstElementChild;
            const butacas = svgElement.querySelectorAll('[id^="butaca"]');
            this.originalColor = this.noDisponibleColor;

            butacas.forEach(circle => {
                circle.setAttribute('seleccionado', 'false');
                const svg_id = this.getButacaId(circle);
                const butaca = butacasFiltered.find(butaca => butaca.svg_id == svg_id);

                if (butaca) {    
                    const title = this.getButacaName(butaca);

                    this.drawPopover(circle, butaca, title);
            
                    circle.setAttribute('fill', '#0CBA31');
                    circle.style.cursor = 'pointer';
                    circle.style.transition = 'fill 0.2s';

                    circle.addEventListener('click', () => {
                        let isSeleccionado = JSON.parse(circle.getAttribute('seleccionado'));

                        setTimeout(() => {
                            if (!this.isPanning) {
                                if (!isSeleccionado) {
                                    circle.setAttribute('fill', this.seleccionadaColor);
                                    circle.setAttribute('seleccionado', 'true');
                                } else {
                                    circle.setAttribute('fill', this.originalColor);
                                    circle.setAttribute('seleccionado', 'false');
                                }
                                this.clickButaca(butaca.id);
                            }
                        }, 150);
                    });
  
                    if (butaca.precios_online.length == 0 && butaca.precios_taquilla.length == 0) {
                        circle.setAttribute('fill', this.noDisponibleColor);
                    }            
                }
            });

            this.svgRendered = tempDiv.firstElementChild;
        },
        clickButaca(butaca_id) {
            let butacaSeleccionada = this.butacas.find(butacas => butacas.id == butaca_id);
            if (butacaSeleccionada) {
                butacaSeleccionada.seleccionada = butacaSeleccionada?.seleccionada && butacaSeleccionada.seleccionada ? false : true;
                if (butacaSeleccionada.seleccionada) {
                    this.butacasSeleccionadas.push(butacaSeleccionada)
                } else {
                    const index = this.butacasSeleccionadas.findIndex(butaca => butaca.id == butacaSeleccionada.id);
                    
                    if (index !== -1) {
                        this.butacasSeleccionadas.splice(index, 1);
                    }
                }
            }

            this.reload();
        },
        getButacaId(circle) {
            const id = circle.id;
            const idParts = id.split("-");

            return idParts[1];
        },
        getButacaName(butaca) {
            const nButaca = butaca.butaca;
            const nFila = butaca.fila;
            const sector = butaca.sector_name;

            if (sector) {
                return `Sector: ${sector} - Fila: ${nFila} - Butaca: ${nButaca}`;
            }

            return `Fila: ${nFila} - Butaca: ${nButaca}`;
        },
        drawPopover(circle, butaca, title = null) {
            let content = '';

            const preciosOnlineContent = this.generatePriceContent(butaca.precios_online);
            if (preciosOnlineContent !== '') {
                content += '<b>Precios online:</b>';
                content += preciosOnlineContent;
            }

            const preciosTaquillaContent = this.generatePriceContent(butaca.precios_taquilla);
            if (preciosTaquillaContent !== '') {
                content += '<b>Precios taquilla:</b>';
                content += preciosTaquillaContent;
            }

            const popoverOptions = {
                title: title,
                content: content,
                trigger: 'hover',
                html: true
            }

            new Popover(circle, popoverOptions);
        },
        generatePriceContent(precios) {
            let content = '';

            content += '<ul class="pb-0 mb-0">';
            if (precios.length > 0) {
                precios.forEach(precio => {
                    content += `<li>${precio.descripcion}`;
                });
            } else {
                content += '<li>No tiene precios configurados</li>'
            }
            content += '</ul>';

            return content;
        },
        reload() {
            this.reloadComponent += 1;
        },
        recargar() {
            this.butacasSeleccionadas = [];
            this.getButacas();
            this.renderLeafletSvg(this.svg);
        }
    },
    computed: {        
        lista_id() {
            return this.$store.getters.getListaId;
        }
    },
    created() {
        this.getButacas();
    },
    components: {
        LeafletComponent, PreciosButacasComponent
    }
}
</script>